import React from 'react';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import { getLanguage, StoreState } from '@store';
import { History, Location } from 'history';
import { match } from 'react-router';
import { Loader, ModalAlert } from '@shared/components';
import { getTheme } from '@theme';
import { AppComponent, WithCoreProps, getLoading } from 'ff-shared-components-core';
import RegisterPharmacyFlow from './flows/RegisterPharmacy/index';
import './App.less';
import { getResources } from '@i18n';

interface AppInjectedProps {
	language: string;
	loading: boolean;
	location: Location;
	match: match;
	history: History;
}

const EntryPointAppComponent: React.FC<AppInjectedProps> = (props: AppInjectedProps) => {
	const { language, loading } = props;

	const theme = getTheme();
	const resources = getResources();

	return (
		<div id="ff-reg-app" className="ff-reg-app">
			<AppComponent theme={theme} resources={resources} language={language}>
				<Loader loading={loading} page />
				<ModalAlert />
				<div className="emptyPageContainer">
					<Route path={'/'} component={RegisterPharmacyFlow} />
				</div>
			</AppComponent>
		</div>
	);
};

const mapStateToProps = (state: StoreState): object => ({
	loading: getLoading(state),
	language: getLanguage(state),
});

export const App = WithCoreProps(withRouter(connect(mapStateToProps, undefined)(EntryPointAppComponent)));
